var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg107Leaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M511.869,21.717c0.025-0.308,0.042-0.618,0.053-0.931c0.368-11.008-8.238-20.242-19.246-20.649 c-2.422-0.089-60.204-2.031-134.658,12.114c-43.903,8.341-84.536,20.591-120.767,36.409c-45.88,20.03-84.843,45.886-115.806,76.85 c-49.052,49.052-73.748,101.765-73.399,156.671c0.311,49.12,20.507,87.333,32.573,110.165c1.208,2.285,2.551,4.828,3.709,7.104 L5.913,477.865c-7.808,7.808-7.808,20.468,0,28.277c3.905,3.904,9.022,5.857,14.14,5.857c5.118,0,10.236-1.953,14.14-5.857 L357.115,183.22c7.808-7.808,7.808-20.468,0-28.277c-7.808-7.809-20.469-7.809-28.278,0L113.953,369.826 c-10.927-20.807-25.683-50.899-25.917-87.898c-0.282-44.433,19.895-86.348,61.687-128.14 C212.01,91.5,300.94,63.899,364.574,51.713c45.441-8.702,84.884-11.012,107.2-11.554 c-1.407,56.352-14.242,222.794-113.619,322.173c-41.793,41.791-83.665,61.976-128.142,61.687 c-12.074-0.077-24.506-1.764-36.949-5.013c-10.682-2.786-21.609,3.609-24.398,14.295c-2.79,10.684,3.609,21.608,14.294,24.398 c15.659,4.09,31.406,6.213,46.802,6.309c0.381,0.003,0.763,0.004,1.146,0.004c54.493,0,106.812-24.692,155.526-73.403 c30.964-30.963,56.818-69.925,76.85-115.805c15.818-36.231,28.067-76.864,36.409-120.767 C512.424,87.013,512.121,33.499,511.869,21.717z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg107Leaf);
export default __webpack_public_path__ + "static/media/107-leaf.7a8b63bbe0675751fd0a025b46034eff.svg";
export { ForwardRef as ReactComponent };